@if (data) {
  @if (data?.values) {
    <section class="structure-container">
      <div class="data-layout">
        <span>{{ 'DASHBOARD.DATA_LAYOUT' | translate }}</span>
        <div>
          <button
            data-cy="dashboard-data-layout-colunn"
            class="layout"
            (click)="setLayout('column')"
            [class.active]="getLayout() === 'column'"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <button
            data-cy="dashboard-data-layout-right"
            class="layout right"
            (click)="setLayout('row')"
            [class.active]="getLayout() === 'row'"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </div>
      </div>
      <p
        class="add-series"
        matTooltip="{{
          !canAddValue() ? ('DASHBOARD.YOU_CANT_ADD_MORE_SERIES' | translate) : null
        }}"
      >
        <span>{{ 'DASHBOARD.DATA' | translate }}</span>
        <button (click)="addValue()" [disabled]="!canAddValue()" data-cy="dashboard-data-series">
          <mat-icon svgIcon="add_circle"></mat-icon>
          {{ 'DASHBOARD.ADD_NEW_SERIES' | translate }}
        </button>
      </p>
      <mat-tab-group [(selectedIndex)]="selectedTabId">
        @for (series of data.values; track series; let i = $index) {
          <mat-tab [bodyClass]="'mat-tab-padding'">
            <ng-template mat-tab-label>
              <div class="label">
                <span>{{ i + 1 }}</span>
                <mat-icon
                  (click)="deleteValue(i); $event.preventDefault(); $event.stopPropagation()"
                  >cancel
                </mat-icon>
              </div>
            </ng-template>
            <ng-template matTabContent>
              <app-dashboard-value-display-settings-input
                [data]="series"
              ></app-dashboard-value-display-settings-input>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    </section>
  }
}
